import { createApiAction, createClearAction } from 'redux/redux-actions';
import restApis from '../restApis';
import {
  LIST_PRESENCES,
  SEND_MESSAGE,
  MESSAGE_READ,
} from '../constants';

const listPresencesApi = restApis('chats/presences').list;
const sendMessageApi = restApis('chats/send-message').create;
const messageReadApi = restApis('chats/message-read').create;

export const clearPresences = createClearAction(LIST_PRESENCES);
export const listPresences = createApiAction(LIST_PRESENCES, listPresencesApi);
export const sendMessage = createApiAction(SEND_MESSAGE, sendMessageApi);
export const messageRead = createApiAction(MESSAGE_READ, messageReadApi);
